import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

import Link from "gatsby-link";

const PrimaryButton = ({ onClick, children, disabled, type, to, inverted }) => {
  const El = type === "link" ? Link : "button";
  const className = inverted ? styles.rootInverted : styles.root;
  return (
    <El className={className} onClick={onClick} disabled={disabled} to={to}>
      {children}
    </El>
  );
};

PrimaryButton.defaultProps = {
  disabled: false,
  type: "button"
};

PrimaryButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "link"]),
  to: PropTypes.string,
  inverted: PropTypes.bool
};

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/components/PrimaryButton/index.js